import { assertUnreachable } from "common/utils/assertUnreachable";
import type { ReactNode } from "react";
import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

interface IconLockedProps extends SvgIconProps {
  variant?: "studio" | "portal";
}

export default function IconLocked({ variant = "portal", ...props }: IconLockedProps): ReactNode {
  switch (variant) {
    case "studio": {
      return (
        <SVGIcon width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
          <path
            d="M5.5 10C5.5 9.72386 5.72386 9.5 6 9.5H12C12.2761 9.5 12.5 9.72386 12.5 10V13C12.5 13.2761 12.2761 13.5 12 13.5H6C5.72386 13.5 5.5 13.2761 5.5 13V10Z"
            stroke="currentColor"
          />
          <path
            d="M6.5 7C6.5 5.61929 7.61929 4.5 9 4.5V4.5C10.3807 4.5 11.5 5.61929 11.5 7V9.5H6.5V7Z"
            stroke="currentColor"
          />
        </SVGIcon>
      );
    }
    case "portal": {
      return (
        <SVGIcon width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
          <path
            d="M6 6C6 4.34315 7.34315 3 9 3V3C10.6569 3 12 4.34315 12 6V9H6V6Z"
            stroke="currentColor"
            strokeWidth="2"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 8C3.89543 8 3 8.89543 3 10V14C3 15.1046 3.89543 16 5 16H13C14.1046 16 15 15.1046 15 14V10C15 8.89543 14.1046 8 13 8H5ZM10 10H8V14H10V10Z"
            fill="currentColor"
          />
        </SVGIcon>
      );
    }
    default: {
      assertUnreachable(variant);
    }
  }
}
